import Link from 'next/link';
import AmpBodyParser from '~/components/bodyParser/ampBodyParser';
import AmpAnalytics from '~/components/ampAnalytics/ampAnalytics';
import AmpGeo from '~/components/ampGeo/ampGeo';
import AmpSkimlinks from '~/components/skimlinks/ampSkimlinks';
import { getDate } from '~/utils/utils';

/**
 * Article Amp
 * @category Functional Component
 * @extends Component
 * @summary Display the AMP version of an article.
 * @prop {Object} data - The page data.
 * @prop {Object} drupalSettings - The drupal settings.
 * @prop {string} pageType - The page type for surrogate utag data.
 * @prop {string} siteSection - The site section for surrogate utag data.
 * @prop {string} keywords - The keywords for surrogate utag data.
 * @return {Node} React node containing AMP article.
 */

const ArticleAmp = props => {
  const { data, drupalSettings, pageType, siteSection, keywords } = props;
  const content = {
    ...data.nodeQuery
  };

  return (
    <>
      <article className='amp-content'>
        {/* Main Image */}
        { content.field_image.field_image &&
          <amp-img
            alt={ content.field_image?.alt }
            src={ content.field_image.field_image.lg.url }
            width={ content.field_image.field_image.lg.width }
            height={ content.field_image.field_image.lg.height }
            layout='responsive'
          ></amp-img>
        }
        <div className='amp-content__body'>
          {/* Title */}
          <h1 className='amp-content__heading'>{ content.title }</h1>
          {/* Is Promotional Flag */}
          { content.field_is_promotional && content.field_flag &&
            <div className='amp-content__flag'>
              { content.field_flag }
            </div>
          }
          {/* Category */}
          { content.field_category && content.field_category.path &&
            <Link legacyBehavior href={ content.field_category.path }>
              <a className='amp-content__category'>
                { content.field_category.name }
              </a>
            </Link>
          }
          {/* Category (if no url) */}
          { content.field_category && content.field_category.path === undefined &&
            <div className='amp-content__category'>
              { content.field_category.name }
            </div>
          }
          {/* Byline */}
          { content.field_byline_text &&
            <div className='amp-content__byline'>
              By: { content.field_byline_text }
              <div className='amp-content__byline-date'>
                { getDate(content.field_display_date) }
              </div>
            </div>
          }
          {/* Skimlinks */}
          { content.field_skimlinks &&
            <AmpSkimlinks
              type={ content.__typename }
              data={ drupalSettings }
            />
          }
          {/* Subhead */}
          { content.field_subhead &&
            <h2 className='amp-content__subheading'>
              { content.field_subhead }
            </h2>
          }
          <AmpBodyParser
            content={ content.body }
            pageType={ pageType }
            siteSection={ siteSection }
            keywords={ keywords }
          />
          <AmpAnalytics data={ content } />
          <AmpGeo />
        </div>
      </article>
    </>
  );
}

export default ArticleAmp;
